export default {
  'get-list': {
    method: 'post',
    url: '/client/trip/list'
  },
  add: {
    method: 'post',
    url: '/client/trip'
  },
  update: {
    method: 'put',
    url: '/client/trip/ID'
  },
  updateModerationStatus: {
    method: 'put',
    url: '/client/trip/moderation-status/ID'
  },
  delete: {
    method: 'delete',
    url: '/client/trip'
  },
  archive: {
    method: 'delete',
    url: '/client/trip/archive'
  },
  finds: {
    method: 'get',
    url: '/client/trip/find?key=KEY'
  },
  detail: {
    method: 'get',
    url: '/client/trip/ID'
  }
}
